import Resource from '@/api/resource';
import request from '@/utils/request';

class CmsPagesResource extends Resource {
  constructor() {
    super('admin/cms-pages');
  }

  list(query) {
    return request({
      url: '/' + this.uri,
      method: 'get',
      params: query,
    });
  }

  store(formData) {
    return request({
      url: '/' + this.uri,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  update(id, formData) {
    return request({
      url: '/' + this.uri + '/' + id,
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  destroy(id) {
    return request({
      url: '/' + this.uri + '/' + id,
      method: 'delete',
    });
  }

  checkSlug(slug, excludeId) {
    return request({
      url: '/' + this.uri + '/check-slug',
      method: 'get',
      params: { slug, exclude_id: excludeId || null },
    });
  }

  generatePreviewLink(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/preview-link',
      method: 'post',
    });
  }
}

export { CmsPagesResource as default };
